import React from 'react';
import QuizBoard from './QuizBoard';

function CountryQuiz() {
    return (  
        <div>
            <div>
                <QuizBoard/>
            </div>
        </div>
    )
}

export default CountryQuiz